import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent {

  constructor(private authService: MsalService, private router: Router) { }

  ngOnInit(): void {
    // console.log('AppComponent initialized');
         
// 
    try {
       const activeAccount = this.authService.instance.getActiveAccount();
      // console.log(activeAccount);
      if (activeAccount) {
        this.router.navigate(['/landing-page']);
      }
    } catch (error) {
      console.error('Error during navigation:', error);
    }
    
  }


  onLogin() {
    this.authService.loginRedirect();
  }


}

